import React, { Component } from "react";

const PlusIcon = ({ width, fill, color }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="10" cy="9.41177" rx="10" ry="9.41177" fill={fill} />
      <path
        d="M14.9811 10.3531H5.01887C4.45283 10.3531 4 9.93476 4 9.41188C4 8.889 4.45283 8.4707 5.01887 8.4707H14.9811C15.5472 8.4707 16 8.889 16 9.41188C16 9.93476 15.5472 10.3531 14.9811 10.3531Z"
        fill={color}
      />
      <path
        d="M11 4.72341V14.0997C11 14.6324 10.5556 15.0586 10 15.0586C9.44444 15.0586 9 14.6324 9 14.0997V4.72341C9 4.19067 9.44444 3.76448 10 3.76448C10.5556 3.76448 11 4.19067 11 4.72341Z"
        fill={color}
      />
    </svg>
  );
};

PlusIcon.defaultProps = {
  width: 20,
  fill: "black",
  color: "#fff",
};

export default PlusIcon;
